import type { DeclaredCoverage } from '@/features/quotes/types/group-life/coverage-schema.types';
import type { CoverageSelection } from '@/features/quotes/utils/group-life/coverage-resolver';
import { getDisplaySumInsuredMax } from '@/features/quotes/utils/group-life/coverage-display.util';
import {
  formatCurrencyBRL,
  formatCurrencyInput,
  parseCurrencyInput,
} from '@/features/quotes/utils/group-life/format';
import { CoverageRowShell, CurrencyControl } from './coverage-row-shell';

type Props = {
  coverage: DeclaredCoverage;
  selection: CoverageSelection | undefined;
  onChange: (next: CoverageSelection) => void;
  disabled?: boolean;
  error?: string;
};

export function DeclaredRow({
  coverage,
  selection,
  onChange,
  disabled,
  error,
}: Props) {
  const enabled = selection?.kind === 'DECLARED' ? selection.enabled : false;
  const capital = selection?.kind === 'DECLARED' ? selection.capital : null;
  // InsureMO IsSIEditable === false → capital fixo, corretor não pode alterar.
  const sumInsuredLocked = coverage.isSumInsuredEditable === false;
  // InsureMO HasSI === 'N' → cobertura SEM capital (ex.: assistências). Não
  // exibe o campo de valor — a cobertura é apenas ligada/desligada.
  const hasSumInsured = coverage.hasSumInsured !== false;
  const display =
    capital == null ? '' : formatCurrencyInput(String(Math.round(capital * 100)));

  const bounds: string[] = [];
  if (coverage.sumInsuredMin != null)
    bounds.push(`Min: ${formatCurrencyBRL(coverage.sumInsuredMin)}`);
  const displayMax = getDisplaySumInsuredMax(coverage);
  if (displayMax != null) bounds.push(`Max: ${formatCurrencyBRL(displayMax)}`);

  return (
    <CoverageRowShell
      name={coverage.name}
      description={coverage.description}
      badge={coverage.isRider ? 'Adicional' : undefined}
      caption={bounds.length ? bounds.join(' · ') : undefined}
      enabled={enabled}
      onToggle={next =>
        onChange({ kind: 'DECLARED', enabled: next, capital })
      }
      disabled={disabled}
      error={error}
      control={
        hasSumInsured ? (
          <CurrencyControl
            value={display}
            onChange={raw =>
              onChange({
                kind: 'DECLARED',
                enabled,
                capital: parseCurrencyInput(raw),
              })
            }
            disabled={disabled || !enabled || sumInsuredLocked}
            invalid={!!error}
          />
        ) : undefined
      }
    />
  );
}
